import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import styles from '../Setting/profile.module.css';
import { profile_api } from '../../Apiconfig';

const Profile = () => {
  const [profileData, setProfileData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const [logoFile, setLogoFile] = useState(null);
  const [previewLogo, setPreviewLogo] = useState(null);

  const [isUploadBox, setIsUploadBox] = useState(true);


  const fileInputRef = useRef(null);

  const fetchProfile = async () => {
    try {
      const response = await axios.get(`${profile_api}get_profile.php`, {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true,
      });

      if (response.data.status === 'success') {
        setProfileData(response.data.data);
        setFormData(response.data.data);
        setPreviewLogo(response.data.data.Logo);
      } else {
        setError(response.data.message || 'Failed to fetch profile data.');
      }
    } catch (err) {
      setError('An error occurred while fetching profile data.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProfile();
  }, []);

  const handleInputChange = (e) => {
    const { name, value, files } = e.target;
    if (name === 'logo' && files && files[0]) {
      const file = files[0];
      setLogoFile(file);
      setPreviewLogo(URL.createObjectURL(file)); // Preview the selected logo
      setIsUploadBox(false);
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleSave = async () => {
    const formDataToSend = new FormData();
    formDataToSend.append('username', formData.username || '');
    formDataToSend.append('email', formData.email || '');
    formDataToSend.append('phone', formData.phone || '');
    formDataToSend.append('shopname', formData.shopname || '');
    if (logoFile) {
      formDataToSend.append('logo', logoFile);
    }

    try {
      const response = await axios.post(`${profile_api}update_profile.php`, formDataToSend, {
        headers: { 'Content-Type': 'multipart/form-data' },
        withCredentials: true,
      });

      if (response.data.status === 'success') {
        setProfileData({ ...formData, logo: previewLogo });
        setIsEditing(false);
        alert('Profile updated successfully!');
      } else {
        alert(response.data.message || 'Failed to update profile.');
      }
    } catch (error) {
      alert('An error occurred while updating profile.');
    }
  };

  const handleCancel = () => {
    setFormData(profileData);
    setLogoFile(null);
    setPreviewLogo(profileData.Logo);
    setIsEditing(false);
  };

  if (loading) {
    return <div className={styles.loading}>Loading...</div>;
  }

  if (error) {
    return <div className={styles.error}>{error}</div>;
  }


  return (
    <div className={styles.profileContainer}>
      <h2>Profile Details</h2>
      <div className="row">
        <div className="col-md-6">
          {isEditing ? (
            <>
              {isUploadBox ? (
                <label for="file" className={styles.custum_fileupload}>
                  <div className={styles.icon}>
                    <svg viewBox="0 0 24 24" fill="" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M10 1C9.73478 1 9.48043 1.10536 9.29289 1.29289L3.29289 7.29289C3.10536 7.48043 3 7.73478 3 8V20C3 21.6569 4.34315 23 6 23H7C7.55228 23 8 22.5523 8 22C8 21.4477 7.55228 21 7 21H6C5.44772 21 5 20.5523 5 20V9H10C10.5523 9 11 8.55228 11 8V3H18C18.5523 3 19 3.44772 19 4V9C19 9.55228 19.4477 10 20 10C20.5523 10 21 9.55228 21 9V4C21 2.34315 19.6569 1 18 1H10ZM9 7H6.41421L9 4.41421V7ZM14 15.5C14 14.1193 15.1193 13 16.5 13C17.8807 13 19 14.1193 19 15.5V16V17H20C21.1046 17 22 17.8954 22 19C22 20.1046 21.1046 21 20 21H13C11.8954 21 11 20.1046 11 19C11 17.8954 11.8954 17 13 17H14V16V15.5ZM16.5 11C14.142 11 12.2076 12.8136 12.0156 15.122C10.2825 15.5606 9 17.1305 9 19C9 21.2091 10.7909 23 13 23H20C22.2091 23 24 21.2091 24 19C24 17.1305 22.7175 15.5606 20.9844 15.122C20.7924 12.8136 18.858 11 16.5 11Z" fill=""></path> </g></svg>
                  </div>
                  <div className={styles.uploadlogotext}>
                    <span>Click to upload image</span>
                  </div>

                  <input
                    type="file"
                    id="file"
                    name="logo"
                    accept="image/jpeg, image/png, image/gif"
                    ref={fileInputRef} // Attach the ref here
                    onChange={handleInputChange} // Attach the handler
                  />
                </label>
              ) : (
                <>
                  {previewLogo && (
                    <img
                      src={previewLogo}
                      className={styles.logoPreview}
                    />
                  )}
                </>
              )}
            </>
          ) : (
            <div>
              {profileData.Logo ? (
                <img
                  src={`${profile_api}/user_logo/${previewLogo}`}
                  alt="Shop Logo"
                  className={styles.logo}
                />
              ) : (
                'No logo uploaded'
              )}
            </div>
          )}
        </div>
        <div className="col-md-6">
          {isEditing ? (
            <>
              <div className={styles.profileItem}>
                <strong>Username:</strong>
                <input
                  type="text"
                  name="username"
                  value={formData.username || ''}
                  onChange={handleInputChange}
                />
              </div>
              <div className={styles.profileItem}>
                <strong>Email:</strong>
                <input
                  type="email"
                  name="email"
                  value={formData.email || ''}
                  onChange={handleInputChange}
                />
              </div>
              <div className={styles.profileItem}>
                <strong>Phone:</strong>
                <input
                  type="text"
                  name="phone"
                  value={formData.phone || ''}
                  onChange={handleInputChange}
                  readOnly
                />
              </div>
              <div className={styles.profileItem}>
                <strong>Shop Name:</strong>
                <input
                  type="text"
                  name="shopname"
                  value={formData.shopname || ''}
                  onChange={handleInputChange}
                />
              </div>
            </>
          ) : (
            <>
              <div className={styles.profileItem}>
                <strong>Username:</strong> {profileData.username || 'Not provided'}
              </div>
              <div className={styles.profileItem}>
                <strong>Email:</strong> {profileData.email || 'Not provided'}
              </div>
              <div className={styles.profileItem}>
                <strong>Phone:</strong> {profileData.phone || 'Not provided'}
              </div>
              <div className={styles.profileItem}>
                <strong>Shop Name:</strong> {profileData.shopname || 'Not provided'}
              </div>
            </>
          )}
        </div>
      </div>
      <div className="row">
        {isEditing ? (
          <>
            <div className={styles.editor_btnsave}>
              <button className={styles.cancelBtn} onClick={handleCancel}>
                Cancel
              </button>
              <button className={styles.saveBtn} onClick={handleSave}>
                Save Changes
              </button>
            </div>
          </>
        ) : (
          <button
            className={styles.editor_btn}
            onClick={() => { setIsEditing(true); console.log(isEditing) }}
          >
            Edit Profile
          </button>
        )}
      </div>
    </div>
  );
};

export default Profile;
